/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPeopleGroup = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 7a2 2 0 0 1 3.333-1.491l1.334-1.49A4 4 0 0 0 5.333 9.98l1.334-1.49A1.993 1.993 0 0 1 6 7zm6-1a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm6.236-5a2 2 0 0 1 1.175 3.619l1.177 1.617a4 4 0 1 0-5.333-5.903l1.49 1.334c.368-.41.899-.667 1.491-.667zM8 21.143c0-1.269.32-2.292.918-2.984C9.494 17.492 10.442 17 12 17s2.506.492 3.083 1.16c.597.691.917 1.714.917 2.983V22h2v-.857c0-1.574-.395-3.122-1.404-4.291C15.565 15.658 14.013 15 12 15s-3.565.658-4.596 1.852C6.394 18.02 6 19.569 6 21.142V22h2zM4.747 15.31C4.26 15.99 4 16.935 4 18.076v.857H2v-.857c0-1.42.32-2.815 1.122-3.933.82-1.144 2.075-1.903 3.74-2.134l.276 1.98c-1.176.164-1.92.663-2.39 1.32zM20 18.077c0-1.141-.26-2.087-.748-2.768-.47-.656-1.214-1.155-2.39-1.319l.276-1.98c1.665.231 2.92.99 3.74 2.134C21.68 15.262 22 16.657 22 18.077v.857h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPeopleGroup as PeopleGroup };
